import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Lock } from "lucide-react";

export function Footer() {
  return (
    <footer className="bg-surface border-t border-white/10 mt-24" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-14 grid gap-10 md:grid-cols-4">
        <div className="space-y-4">
          <Logo className="h-10" showText />
          <p className="text-sm text-slate-400 leading-relaxed">
            Online IT courses, exams, and certifications. Learn, prove, certify, advance.
          </p>
          <p className="text-xs font-mono uppercase tracking-[0.2em] text-gold">LEARN • PROVE • CERTIFY • ADVANCE</p>
        </div>
        <div>
          <h4 className="font-display font-semibold text-white mb-4">Platform</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li><Link to="/courses" className="hover:text-gold">Courses</Link></li>
            <li><Link to="/verify" className="hover:text-gold">Verify Certificate</Link></li>
            <li><Link to="/about" className="hover:text-gold">About us</Link></li>
            <li><Link to="/account" className="hover:text-gold">My Account</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-semibold text-white mb-4">Legal</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li><Link to="/policies/privacy" className="hover:text-gold">Privacy Policy</Link></li>
            <li><Link to="/policies/terms" className="hover:text-gold">Terms & Conditions</Link></li>
            <li><Link to="/policies/cookies" className="hover:text-gold">Cookie Policy</Link></li>
            <li><Link to="/policies/exam_conditions" className="hover:text-gold">Exam Conditions</Link></li>
            <li><Link to="/policies/scheme" className="hover:text-gold">Certification Scheme</Link></li>
            <li><Link to="/policies/proctoring" className="hover:text-gold">Proctoring Regulation</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-display font-semibold text-white mb-4">Contact</h4>
          <p className="text-sm text-slate-400 leading-relaxed">
            <span className="inline-flex items-center gap-1.5"><Lock className="h-3.5 w-3.5 text-gold" /> Direct email &amp; phone are for </span>
            <Link to="/contact" className="text-gold underline">signed-in members</Link>. Everyone else can use our AI assistant.
          </p>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} Certalyth Academy. All rights reserved.
      </div>
    </footer>
  );
}
